import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ApiService } from 'src/app/services/api.service';
import { Location } from '@angular/common';

@Component({
  selector: 'fury-category-details',
  templateUrl: './category-details.component.html',
  styleUrls: ['./category-details.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class CategoryDetailsComponent implements OnInit {

  categoryDetails: any;

  constructor(
    private activatedroute: ActivatedRoute,
    private apiservice: ApiService,
    private router: Router,
    public location: Location,
  ) { }

  ngOnInit(): void {
    this.activatedroute.params.subscribe((res: any) => {
      if(res.id) {
        this.getCategoryDetails(res.id);
      } else {
        this.location.back();
      }
    });
  }
  getCategoryDetails(categoryId: string) {
    this.apiservice.get(`admin/home-owner/category/get-home-owner-category/${categoryId}`).subscribe((res: any) => {
      if (res.body) {
        this.categoryDetails = res.body.homeOwnerCategory;
      }
    }, err => {
      this.apiservice.alert(err.error.message, ErrorType.Error);
      this.location.back();
    });
  }

}
